import React from 'react'

export type ElementContextProps = {
  config: {
    close: () => void
  }
  edit: {
    enter: () => void
    exit: () => void
  }
  state: {
    save: () => void
  }
  status: {
    selected: boolean
    onlySelected: boolean
    edited: boolean
    preview: boolean
  }
  delete: () => void
}

// This context provide utility methods to brige an isolated component (ExportableComponent or Config) to the parent report.
// The isolated component have they own Recoil Root, so to sync this internal root to the report definition
// we need to use this context.
export const ElementContext = React.createContext<ElementContextProps | undefined>(undefined)

export const useElement = () => {
  const result = React.useContext(ElementContext)
  if (!result) {
    return undefined
  }
  return result
}
